export const SYSTEM_MUTATION_SET_RESOLUTION_TYPE = 'system_mutation_set_resolution_type'
export const SYSTEM_MUTATION_SET_NORMATIVE_DOCUMENTS = 'system_mutation_set_normative_documents'

export const SYSTEM_GETTER_GET_RESOLUTION_TYPE = 'system_getter_get_resolution_type'
export const SYSTEM_GETTER_CHECK_RESOLUTION_TYPE = 'system_getter_check_resolution_type'
export const SYSTEM_GETTER_GET_NORMATIVE_DOCUMENTS_LIST = 'system_getter_get_normative_documents_list'

export const SYSTEM_ACTION_FETCH_NORMATIVE_DOCUMENTS = 'system_action_fetch_normative_documents'
